export var filterMixin = {
  data: function data() {
    return {
      filterEnabled: false
    };
  },
  methods: {
    onEnableFilter: function onEnableFilter() {
      this.filterEnabled = !this.filterEnabled;
    }
  },
  computed: {
    getClass: function getClass() {
      if (this.filterEnabled) {
        return 'col-md-9 col-12 order-md-first order-last';
      } else {
        return 'col-12 order-md-first order-last';
      }
    }
  }
};